export const isValidRedirectUri = (value?: string) => {
    if (!value) {
        return false;
    }
    try {
        const url = new URL(value);

        return !value.includes('*') && !url.hash && (url.protocol === 'https:' || url.hostname === 'localhost');
    } catch {
        return false;
    }
};

export const validateRedirectUri = (_rule: unknown, value?: string) => {
    if (!value) {
        return Promise.resolve();
    }

    try {
        const url = new URL(value);

        if (value.includes('*')) {
            return Promise.reject(new Error('Wildcards are not allowed in redirect URIs'));
        }
        if (url.hash) {
            return Promise.reject(new Error('Redirect URIs must not contain URL fragments (#)'));
        }
        if (url.protocol !== 'https:' && url.hostname !== 'localhost') {
            return Promise.reject(new Error('Redirect URIs must use HTTPS, except for localhost'));
        }

        return Promise.resolve();
    } catch {
        return Promise.reject(new Error('Enter a valid redirect URI'));
    }
};
